
export const areas ={
    
    Seccional: 1, 
    Nacional: 2,
}